(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('painelEdicaoDemarcacao', PainelEdicaoDemarcacao);

  function PainelEdicaoDemarcacao() {
    return {
      restrict: 'E',
      controller: 'EdicaoDemarcacaoCtrl',
      controllerAs: 'demarcacao',
      templateUrl: 'views/propriedade/demarcacao-edicao.html',
      scope: {
        data: '<'
      }
    };
  }

}());
